export const AuthTokenLocalStorageKey = "AuthToken";

let currentAuthToken: string | null = null;

export function resetAuthToken(): void {
	currentAuthToken = null;
	try {
		localStorage.removeItem(AuthTokenLocalStorageKey);
	} catch (err) {
		log.error(err);
	}
}

export function setAuthToken(token: string): void {
	currentAuthToken = token;
	try {
		localStorage.setItem(AuthTokenLocalStorageKey, token);
	} catch (err) {
		log.error(err);
	}
}

export function getAuthToken(): string | null {
	try {
		const token = localStorage.getItem(AuthTokenLocalStorageKey);
		return token;
	} catch (err) {
		log.error(err);
	}
	return currentAuthToken;
}

export function authTokenExists(): boolean {
	try {
		const tokenExists = getAuthToken() != null;
		return tokenExists;
	} catch (err) {
		log.error(err);
	}
	return currentAuthToken != null;
}
